import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  static values = { disappear: Boolean }

  connect() {
    if (Notification.permission === "granted") {
      this.markNotificationsAsEnabled()
    }
  }

  askPermission() {
    var _this = this

    if (!("Notification" in window)) {
      App.displayFlash("danger", "Notifications are not supported by your browser.")
    } else if (Notification.permission !== "granted") {
      Notification.requestPermission(function (permission) {
        if (permission === "granted") {
          App.displayFlash("success", "Notifications activated.")
          _this.markNotificationsAsEnabled()
        } else {
          App.displayFlash("danger", "Notifications are blocked by your browser.")
        }
      })
    }
  }

  markNotificationsAsEnabled() {
    if (this.disappearValue) {
      this.buttonTarget.style.display = "none"
    } else {
      this.buttonTarget.innerHTML = "<div class='far fa-check'></div> Notifications activated"
    }
  }
}
